module.exports = __webpack_public_path__ + "static/media/youstyLogo.ef35a10a.svg";